import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private notificationCount = new BehaviorSubject<number>(0);
  notificationCount$ = this.notificationCount.asObservable();

  incrementCount() {
    this.notificationCount.next(this.notificationCount.value + 1);
  }

  resetCount() {
    this.notificationCount.next(0);
  }
} 
